export default {
  registration: {
    give_mandate: {
      badge_tooltip: "Mandato de gestión concedido",
    },
    invoice: {
      filter: {
        active: "Filtros activos",
        remove: "Quitar el filtro {name}",
        status: "Filtrar por estado",
      },
      title: ({ plural }) => plural(["Factura", "Facturas"]),
      global_totals: ({ plural, named }) =>
        plural([
          `${named("count")} vencimiento en total en este flujo (facturado o no)`,
          `${named("count")} vencimientos en total en este flujo (facturados o no)`,
        ]),
      flow: {
        all: "Todos los flujos",
        opco: "OPCO",
        company: "Empresa",
      },
      emitted: {
        title: ({ plural }) => plural(["Factura emitida", "Facturas emitidas"]),
        resend: "Reenviar la factura",
        resend_reference: "Reenviar la factura {reference}",
        resend_confirmation: "¿Está seguro de que desea reenviar esta factura?",
        selected: ({ plural, named }) =>
          plural([`${named("count")} factura seleccionada`, `${named("count")} facturas seleccionadas`]),
        export: ({ plural, named }) =>
          plural([`Exportar (${named("count")} factura)`, `Exportar (${named("count")} facturas)`]),
        export_selection: ({ plural, named }) =>
          plural([
            `Exportar la selección (${named("count")} factura)`,
            `Exportar la selección (${named("count")} facturas)`,
          ]),
        deposit_selection: ({ plural, named }) =>
          plural([
            `Declarar presentada la factura seleccionada (${named("count")})`,
            `Declarar presentadas las facturas seleccionadas (${named("count")})`,
          ]),
        see_error: "Ver los errores",
        error_date: "Fecha del error: {date}",
        resend_rejection: {
          title: "No se pudo reenviar la factura",
          reference: "Factura",
          dismiss: "Cerrar el mensaje de error de reenvío",
        },
        see_details: "Ver el detalle",
        download_pdf: "Descargar la factura",
        download_completion_certificate: "Descargar el certificado de realización",
        deposit: {
          cancel: "Cancelar",
          cancel_deposit: "Cancelar la presentación",
          cancel_deposit_confirmation: "¿Cancelar la presentación de esta factura?",
          choose_another_date: "Elegir otra fecha",
          form_title: "Modificar la fecha de presentación",
          declare_deposit: "Declarar como presentada",
          declare_confirm_title: "¿Está seguro de que desea declarar esta factura como presentada?",
          edit_confirm_title: "¿Está seguro de que desea modificar la fecha de presentación de esta factura?",
          platform_title: "Presentación en la plataforma",
          platform_error_message:
            "El envío al OPCO ha fallado. Si ha presentado esta factura directamente en la plataforma del OPCO, puede declararlo aquí.",
          date_updated_success: "¡Fecha de presentación modificada con éxito!",
          selection_confirm_title: ({ plural, named }) =>
            plural([
              `¿Declarar presentada la factura seleccionada (${named("count")})?`,
              `¿Declarar presentadas las facturas seleccionadas (${named("count")})?`,
            ]),
          selection_confirm_text:
            "Solo se declararán presentadas las facturas pendientes de presentación, las demás se ignorarán",
          selection_result: "{deposited} y {ignored}",
          selection_deposited: ({ plural, named }) =>
            plural([
              "Ninguna factura declarada presentada",
              `${named("count")} factura declarada presentada`,
              `${named("count")} facturas declaradas presentadas`,
            ]),
          selection_ignored: ({ plural, named }) =>
            plural([`${named("count")} factura ignorada`, `${named("count")} facturas ignoradas`]),
        },
      },
      retry: {
        tooltip: "Reintentar la generación del PDF",
        success: "La generación del PDF se ha reintentado con éxito.",
      },
      credit_note: {
        document_title: "Abono",
        download_pdf: "Descargar el abono",
        emit: "Emitir un abono",
        title: "Emisión de un abono",
        confirm: "¿Está seguro de que desea emitir este abono?",
        success: "¡Abono emitido con éxito!",
        type_total: "Abono total",
        type_partial: "Abono parcial",
        confirm_irreversible: "Esta acción es definitiva y no se podrá deshacer.",
        pdf_failed: "El abono se ha creado pero no se ha podido generar su PDF.",
        pdf_failed_retry: "¿Desea reintentar la generación del PDF ahora?",
        see_origin_invoice: "Ver la factura de origen",
        see_origin_invoice_label: "Ver la factura de origen N.º {code}",
      },
      attached_credit_notes: {
        title: ({ plural, named }) =>
          plural([
            `Esta factura ha sido objeto de ${named("count")} abono`,
            `Esta factura ha sido objeto de ${named("count")} abonos`,
          ]),
        number: "Abono N.º {number}",
        issued_at: "Emitido el {date}",
        reason: "Motivo: {reason}",
        see_credit_note: "Ver el abono",
        see_credit_note_label: "Ver el abono N.º {number}",
      },
      schedule: {
        title: ({ plural }) => plural(["Vencimiento a facturar", "Vencimientos a facturar"]),
        selected: ({ plural, named }) =>
          plural([`${named("count")} vencimiento seleccionado`, `${named("count")} vencimientos seleccionados`]),
        total_amount: "Importe total: {amount}",
        cancel_selection: "Cancelar la selección",
        emit: "Emitir las facturas",
        export: ({ plural, named }) =>
          plural([`Exportar (${named("count")} vencimiento)`, `Exportar (${named("count")} vencimientos)`]),
        export_selection: ({ plural, named }) =>
          plural([
            `Exportar la selección (${named("count")} vencimiento)`,
            `Exportar la selección (${named("count")} vencimientos)`,
          ]),
        emit_confirmation: ({ plural, named }) =>
          plural([
            `¿Emitir la factura del vencimiento seleccionado?`,
            `¿Emitir las facturas de los ${named("count")} vencimientos seleccionados?`,
          ]),
        emit_progress: {
          title: "Emisión de facturas en curso",
          label: "Facturas emitidas: {done} / {total}",
        },
        rejection: {
          title: ({ plural, named }) =>
            plural([
              `${named("count")} vencimiento no pudo ponerse en cola de facturación`,
              `${named("count")} vencimientos no pudieron ponerse en cola de facturación`,
            ]),
          reference: "Vencimiento",
          reason: "Motivo",
          dismiss: "Cerrar el mensaje de vencimientos rechazados",
        },
      },
      emit: {
        title: "Emitir las facturas",
        summary: {
          line: "Su selección comprende {schedules} para {recipients}, por un total de {amount}.",
          schedules: ({ plural, named }) => plural([`${named("count")} vencimiento`, `${named("count")} vencimientos`]),
          recipients: ({ plural, named }) =>
            plural([`${named("count")} destinatario`, `${named("count")} destinatarios`]),
        },
        cancel: "Cancelar",
        confirm: "Emitir las facturas",
        alerts: {
          title: ({ plural }) => plural(["Alerta a revisar", "Alertas a revisar"]),
          show: "Mostrar las alertas",
          hide: "Ocultar las alertas",
          block_show: "Mostrar las alertas de este destinatario",
        },
        channel: {
          api_opco: "API OPCO",
          platform: "Depósito en plataforma",
          email: "Envío por correo electrónico",
          unknown: "Canal desconocido",
          region_label: "Vencimientos del canal {channel}",
        },
        block_total: "Total con impuestos: {amount}",
        empty: "Ningún vencimiento en este canal.",
      },
    },
    name: "Nombre",
    institution: "Establecimiento",
    component: "Componente",
    trainingCourse: "Promoción",
    group: "Grupo",
    Contact: "Contacto",
    registration_settings: "Configuración de inscripción",
    pedagogicInformations: "Información educativa",
    fundingInformations: "Información financiera",
    dates: "Fechas",
    from_to: "de {from} al {to}",
    hourlyVolume: "Volumen horario",
    hourlyRemoteVolume: ({ named }) => `De los cuales ${named("volume")} h a distancia`,
    hourlyCost: "Coste horario de la prestación",
    prestationCost: "Importe de la prestación - Neto de impuestos",
    amount: "Importe",
    modality: ({ plural }) => plural(["Modalidad", "Modalidades"]),
    in_person: "Presencial",
    distanciel: "A distancia",
    remoteVolume: "Incluida la enseñanza a distancia",
    degreePrepared: "Diploma preparado",
    level: "Nivel",
    titleRncp: "Cualificación RNCP",
    degreeCode: "Código del diploma",
    calendar: "Calendario",
    program: "Programa",
    apprenticeShipContract: "Contrato de aprendizaje",
    proContract: "Contrato de profesionalización",
    rate: "Tarifa",
    publicAnnualRate: "Coste anual para los empleadores del sector público",
    annualRate: "Coste anual",
    totalRate: "Coste total",
    hourlyRate: "Precio por hora",
    followUp: "Seguimiento",
    devices: "Dispositivos",
    createdAt: "crea el {date}",
    help: "Ayuda",
    follow: "Seguimiento",
    inProgress: "En curso",
    validatedAt: "Validado el {date} pro {validator}",
    steps: "Las etapas",
    statistics: "Estadísticas",
    pending: "En cours",
    publicSector: "Sector público",
    privateSector: "Secteur privado",
    link_copied_success: "¡Enlace copiado correctamente al portapapeles!",
    head_office: "Sede social",
    status: {
      upcoming: "Próximamente ",
      in_progress: "En curso",
      finalised: "Finalisé",
      break_up: "Ruptura",
      cancelled: "Cancelado",
    },
    insee_company: {
      title: ({ plural }) => plural(["Empresa INSEE ", "Empresas INSEE"]),
      siret: "SIRET",
      activity: "Actividad (NAF/APE)",
      details: "Detalles (nombre, enseña, dirección)",
      creation: "Creación",
      state: "Estado",
      social_reason: "Razón social",
      current: "Establecimiento habitual",
      head_office: "Sede de la empresa",
      creation_date: "Fecha de creación",
      work_force: "Plantilla",
      status: "Estatuto",
      principal_address: "Dirección principal",
      secondary_address: "Dirección secundaria",
      empty_contact: "No hay ningún contacto registrado para esta empresa",
      undefined_work_force: "No hay datos registrados",
    },
    training_info: {
      search_by_branch: "Buscar por convenio colectivo",
      funding_coverage: "Cobertura de financiación:",
      decree_cost: "Costo decreto:",
      only_different_cost_displayed: "Por defecto, solo se muestran los costos distintos del costo decreto",
      info_tab: {
        general_info: "Información general",
        rncp_sheet: "Ficha RNCP",
        program: "Programa",
        setttings: "Configuración de inscripción",
        matrix: "EU Competence Matrix",
        settings: "Configuración de inscripción",
        npec: "NPEC",
        contact: "contacto para las empresas",
      },
      general_info: {
        institution_name: "Nombre de la institución",
        reference: "Referencia",
        rncp_number: "Número RNCP",
        offical_name: "Nombre oficial",
        diplome_type: "Tipo de diploma",
        mention: "Nombre / mención",
        route: "Itinerario",
        diplome_code: "Código del diploma",
        status: "Estado",
        logo: "Logo",
        partner_website_url: "URL del sitio del socio",
        link: "Enlace",
        work_study_duration: "Duración de la formación en alternancia",
        total_cycle_time: "Duración total del ciclo",
        active: "Activa",
        archived: "Archivada",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Alerta ", "Alertas"]),
      level: {
        info: "Información",
        warning: "Alerta",
        error: "Error",
      },
      active_unactive: "Activar/Desactivar",
      see_more: "Ver más",
      empty: "No hay alertas de nivel {level}",
    },
    group_action: {
      see_sheet: "Ver la ficha de preinscripción",
      see_contract: "Ver el contrato",
      duplicate: {
        title: "Duplicar la ficha",
        confirmation: {
          title: "¿Está seguro de que desea duplicar esta ficha?",
          subtitle:
            "Se creará una nueva ficha a partir de la información de la pestaña aprendiz. La ficha original no se modificará.",
        },
        success: "¡Nueva ficha creada con éxito!",
      },
      copy_sheet: "Copiar el enlace de la ficha de preinscripción",
      create: "Crear una ficha de preinscripción",
      cancel: {
        title: "Cancelar esta ficha de preinscripción",
        confirmation: {
          title: "¿Está seguro de que desea cancelar esta ficha?",
          subtitle:
            "La inscripción ya no será visible desde el panel de control, pero podrá restaurarla seleccionando las fichas «canceladas».",
          apprentice_subtitle: "La inscripción ya no será visible desde el panel de control.",
        },
        success: "¡Ficha de preinscripción cancelada con éxito!",
        reset: {
          title: "Reactivar esta ficha de preinscripción",
          confirmation: {
            title: "¿Está seguro de que desea reactivar esta ficha?",
            subtitle: "La ficha será reactivada y volverá a ser visible para los demás usuarios",
          },
          success: "¡Ficha de preinscripción reactivada con éxito!",
        },
      },
      see_group_detail: "Ver detalles del grupo",
      contact_list: "Lista de contactos",
      delete: {
        confirmation: "¿Está seguro de que desea eliminar este grupo?",
        success: "¡Grupo eliminado correctamente!",
      },
      download: {
        commitments: "Descargar el certificado de compromiso",
      },
    },
    dashboard: {
      go_to: "Acceder al panel de esta formación",
      go_to_institution: "Acceder al panel del centro",
    },
    creation: {
      alert: {
        title: "Ya existe una inscripción para esta formación",
        multipleTitle: "Ya tiene inscripciones para esta formación",
      },
      info: "Para crear una nueva ficha de inscripción, introduzca primero la información del candidato",
      success: ({ named }) =>
        `¡El formulario de preinscripción para ${named("firstName")} ${named("lastName")} se ha creado correctamente!`,
    },
    user_not_connected: "Debe iniciar sesión para acceder a este espacio.",
    quote: {
      contract: "Contrato",
      financial: "Financiación",
      amount: "Cuadrícula de importes",
      edit_cost: "Modificar los costos",
      subtitle: "Resumen financiero del contrato de aprendizaje",
      initial_cost: "Costo inicial",
      final_cost: "Costo final",
      modal_alert:
        "Estos cambios afectarán el importe facturado a la empresa. Asegúrese de que los importes cumplen con su convenio.",
      updated_cost: ({ plural, named }) => plural(["1 importe modificado", `${named("number")} importes modificados`]),
      no_updated_cost: "Ningún importe modificado",
      edit: {
        date: {
          title: "Modificar las fechas de la formación (para este expediente)",
          success: "¡Modificación de las fechas de la formación realizada con éxito!",
        },
        cost: {
          title: "Modificar los importes",
          success: "¡Importes modificados con éxito!",
          reset_cost: "Restablecer los importes",
          confirmation: "¿Está seguro de que desea validar estos importes?",
          reset_confirmation: "¿Está seguro de que desea restablecer estos importes?",
          reset_success: "¡Importes restablecidos con éxito!",
          previous_amount: ({ named }) => `anteriormente ${named("amount")}`,
          reference_legend: ({ named }) => `importes del convenio/presupuesto enviado el ${named("date")}`,
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Costo de la formación",
          opcoo: "Asistencia",
          mandatory_participation: "Contribución obligatoria",
          mandatory_participation_tooltip:
            "Parte de la financiación impuesta por el dispositivo o el financiador.\n" +
            "Se añade, en su caso, al resto a cargo.\n" +
            "De conformidad con el artículo L6332-14 del Código del Trabajo francés, se puede solicitar una contribución al empleador.",
          remaining_cost: "Costo restante",
          remaining_cost_tooltip:
            "Importe no cubierto por el financiador.\n" +
            "Es distinto de la contribución obligatoria y depende de las condiciones de cobertura validadas por el OPCO.",
        },
      },
      duration: {
        title: "Duración",
      },
      startDate: {
        title: "Fecha de inicio",
      },
      endDate: {
        title: "Fecha de fin",
      },
      caption: {
        title: "* Importes sin IVA – exención de IVA",
        subtitle: "(art. 261, 4-4° del CGI, actividad de enseñanza).",
      },
      title: "Presupuesto",
      verify: "Verificar el presupuesto",
      cost_historic: "Historial de versiones — Tabla financiera",
      convention: {
        title: "Convenio",
      },
    },
    contact: {
      title: "Un contacto",
      success: "¡Contacto añadido con éxito!",
      info: "Indique la persona de contacto en la empresa. Puede añadir varios contactos en caso de ausencia. El contacto recibirá el correo electrónico al validar el paso.",
      edit_succes: "¡Contacto modificado con éxito!",
      edit: {
        success: "¡Contacto modificado con éxito!",
        alert: "Estos cambios se aplican a la cuenta de usuario en toda la plataforma.",
      },
      delete: {
        confirmation: "¿Está seguro de que desea eliminar este contacto?",
        success: "¡Contacto eliminado con éxito!",
      },
      director: "Dirigente/a / Signatario/a",
      temporary: "Contacto temporal",
      interlocutor: "Interlocutor/a gestión administrativa",
      billing: "Contacto de facturación",
      attendance: "Contacto de asistencia",
      gestionnary: "Gestor/a",
      different_name: "Este nombre aparecerá en el convenio pero no crea una cuenta de usuario.",
      mail_status: {
        waiting: "En espera de activación",
        send: "Email enviado",
        active: "Activo",
      },
      account: {
        already_exist: {
          title: "Esta cuenta ya existe",
          subtitle:
            "La dirección de correo electrónico introducida ya está en uso por una cuenta (1 correo = 1 usuario). El titular de la cuenta puede modificar sus datos en su espacio personal",
        },
      },
      registration: {
        title: "Contacto de inscripción",
        empty: "No hay ningún contacto de inscripción registrado",
      },
      company: {
        title: "Contacto de empresa (interlocutor de RRHH)",
        empty: "No hay ningún contacto de empresa registrado",
      },
    },
    reminder: {
      title: "Reenviar la notificación del enlace de empresa",
      confirmation: {
        title: "¿Está seguro de que desea reenviar la notificación del enlace de empresa?",
      },
      send: "Enviar",
      success: "¡Notificación enviada con éxito!",
    },
    comment: {
      title: "Comentarios",
      new: "Nuevo",
      unread: ({ plural }) => plural(["Mensaje no leído", "Mensajes no leídos"]),
      actions: ({ plural }) => plural(["Acción requerida", "Acciones requeridas"]),
      add: "Agregar un comentario",
      empty: "Ningún comentario registrado",
      action_required: {
        done: "He realizado esta acción",
        doneBy: "Acción realizada por",
      },
      delete: {
        success: "¡Comentario eliminado con éxito!",
        confirmation: "¿Está seguro de que desea eliminar este comentario?",
      },
    },
    contractType: {
      apprentice: "Aprendices",
      pro: "Contrato de profesionalización",
    },
    document: {
      cerfa: {
        title: "CERFA",
        notice: "Ver las instrucciones",
      },
      convention: {
        title: "Convención",
      },
      update: {
        success: ({ named }) => `¡Tu ${named("document")} se ha guardado correctamente!`,
      },
      upload_at: `Depositado el {date}`,
      version: "Versión",
      status: {
        correction_requested: "Corrección solicitada",
        verified: "Verificado",
        sent: "Enviado",
        deposited: "Depositado",
        to_send: "Por enviar",
        to_be_modified: "Modificación requerida",
        validated: "Validado",
        to_verify: "Por verificar",
      },
      actual_version: "Versión actual",
      delete: {
        confirmation: "¿Está seguro de que desea eliminar esta versión?",
        success: "¡Versión eliminada con éxito!",
      },
      validate: {
        confirmation: "¿Está seguro de que desea validar este documento?",
        success: "¡Documento validado con éxito!",
      },
      change: {
        title: "Solicitud de corrección",
        success: "¡Solicitud de complemento enviada con éxito!",
        cancel: {
          confirmation: "¿Está seguro de que desea cancelar esta solicitud de complemento?",
          success: "¡Solicitud de complemento cancelada con éxito!",
        },
      },
      verification: {
        title: "Verificar los documentos",
        modal: "Verificación",
        ask_modification: "Solicitud de modificación",
        cancel_ask_modification: "Cancelar la solicitud de complemento",
        sign: "Visar el documento",
      },
      empty: "Ningún archivo encontrado",
      error: "Se ha producido un error al mostrar el pdf",
      uploaded: "Archivo depositado",
      generated: "Archivo generado",
      validation: {
        not_verify: "El CERFA y la convención deben estar verificados para validar esta etapa",
      },
    },
    step: {
      in_progress: "Etapa en curso",
      validation: {
        success: "¡Etapa completada con éxito!",
      },
    },
    stamp: {
      action: "Modo sello",
      stamped: { confirmed: "¡Documento sellado correctamente!" },
      cancel: "Salir del modo sello",
      tooltip: "Sellar el PDF,\nel sello aparecerá,\nen el centro del cursor\n(tamaño: 90x40 mm)",
      remove: {
        title: "Quitar el sello",
        confirmation: "¿Está seguro de que desea quitar el sello?",
        success: "Sello quitado correctamente",
      },
    },
    save: {
      success: "¡Su formulario de inscripción se ha registrado correctamente!",
    },
    resend_documents: {
      title: "Reenviar los documentos",
      confirmation: "Está a punto de reenviar los documentos a la empresa {company}.",
      confirm: "Confirmar el reenvío",
      success: "Documentos reenviados a la empresa",
      no_document:
        "Debe archivar al menos uno de los dos documentos depositados por la empresa para reenviarlos a firma.",
    },
    request_changes: {
      title: "Solicitud de complemento",
      confirmation: "¿Está seguro de que desea enviar esta solicitud de complemento?",
      success: "¡Solicitud de complemento enviada con éxito!",
      recipients: "La solicitud de complemento será enviada a los siguientes destinatarios:",
      requestAt: "Solicitud de complemento realizada el {date} por {validator}",
      cancel: {
        confirmation: "¿Está seguro de que desea cancelar esta solicitud de complemento?",
        success: "¡Solicitud de complemento cancelada con éxito!",
      },
      new_submission: {
        confirmation: "¿Está seguro de que desea realizar una nueva presentación del formulario?",
        success: "¡Formulario enviado de nuevo con éxito!",
      },
    },
    create: {
      confirmation: "¿Está seguro de que desea crear una nueva ficha de preinscripción?",
      alert: {
        confirm: "Acceder a su ficha existente",
        cancel: "Crear una nueva ficha",
        multipleConfirm: "Acceder a sus fichas",
      },
    },
    contract: {
      title: "Contrato",
      see_more: "Ver más",
      see_less: "Ver menos",
      empty: "Ningún contrato disponible",
      see: "Acceder al contrato",
      error: "Algunos datos no son correctos, corríjalos por favor en la ficha de inscripción",
      synchronize: {
        confirm: "¿Está seguro de que desea sincronizar este OPCO?",
        success: "¡Sincronización finalizada con éxito!",
      },
      opco: {
        edit: {
          success: "¡Información OPCO modificada con éxito!",
        },
      },
      billing: {
        title: "Resumen financiero del contrato",
      },
    },
    empty_registation_list: "Ninguna ficha de preinscripción disponible",
    company_dashboard: {
      following_contract: {
        title: "Lista de contratos",
      },
    },
    contract_status: {
      init: "Inicializada",
      to_send_to_training_center: "Para enviar",
      sent_to_training_center: "Enviada",
      validated_training_center: "Validado",
      signed: "Firmado",
      error: "Error",
      archived: "Archivado",
    },
    years: "años",
    workInProgress: "Trabajo en progreso",
    valid: "Validar",
    uaiCode: "Código UAI",
    tutor: "Tutor",
    ufa: "UFA",
    cfa: "CFA",
    training: "Entrenamiento",
    totalWorkForce: "Mano de obra total",
    socialReason: "Razón social",
    signIn: "Crear cuenta",
    see_more: "Ver más",
    pricePolicyInfo3: "La tarifa se alinea con la cobertura.",
    pricePolicyInfo2:
      "Cargo restante solo si la cobertura es inferior a la tarifa; si es superior, se aplica la tarifa según la cobertura.",
    pricePolicyInfo1:
      "Cargo restante solo si la cobertura es menor; cobertura limitada a la tarifa, incluso si es superior.",
    previousSituation: "Situación anterior",
    prev: "Anterior",
    preContractSituation: "Situación previa al contrato",
    phone: "Teléfono",
    opco: "OPCO",
    opcoComparison: {
      title: "Comparación de datos",
      caption: "Comparación de los datos OPCO y Studea",
      baseline: "Datos OPCO y datos Studea",
      empty: "No hay datos que comparar",
      label: "Etiqueta",
      seeDifferences: "Ver las diferencias",
      level: {
        minor: "Diferencia menor",
        strict: "Diferencia importante",
      },
    },
    salaryDetail: {
      empty: "No hay datos de remuneración",
    },
    noNeedAccount: "Ya tengo una cuenta",
    next: "Siguiente",
    needAccount: "No tengo una cuenta",
    nationality: "Nacionalidad",
    map: "Supervisor de aprendizaje",
    male: "Sr.",
    loginInfo2: "Inicie sesión para acceder al formulario de registro",
    loginInfo: "Inicie sesión o cree una cuenta para acceder al formulario de registro",
    login: "Iniciar sesión",
    lastInstitution: "Última institución",
    lastDegreePrepared: "Último título preparado",
    lastDegreeObtained: "Último título obtenido",
    ineCode: "Código INE",
    idcc: "IDCC",
    iAm: "Soy",
    hourlyTrainingVolume: "Número de horas",
    hostCompanyContact: "Contacto de empresa anfitriona",
    hostCompany: "Empresa anfitriona",
    generalInformations: "Información general",
    function: "Función",
    firstName: "Nombre",
    female: "Sra.",
    employerType: "Tipo de empleador",
    employerSubType: "Subtipo de empleador",
    email: "Correo electrónico",
    download_training_sheet: "Descargar hoja de capacitación",
    ypareo: {
      title: "Ypareo",
      sync_button: "Sincronizar con Ypareo",
      sync_success: "Expediente sincronizado con Ypareo",
      sync_error: "Error en la sincronización con Ypareo",
      running: "Sincronización en curso…",
      error_indicator: "Error de sincronización",
      synced_at: "Sincronizado el {date} (ID Ypareo {id})",
      resend_button: "Reenviar",
      log_title: "Registro de sincronización Ypareo",
      log_date: "Fecha",
      log_created: "Creado",
      log_updated: "Actualizado",
      log_excluded: "Omitido",
      log_errors: "Errores",
      log_empty: "No hay registro disponible para este expediente.",
      error_tooltip: "Error de sincronización Ypareo: {ypareo_sync_error}",
    },
    department: "Departamento",
    degree: "Título",
    createCompanyAccount: "Crear cuenta de empresa",
    createApprenticeAccount: "Crear cuenta de aprendiz",
    contacts: "Contactos",
    company: "Empresa",
    civility: "Cortesía",
    birthDate: "Fecha de nacimiento",
    apprenticeMaster2: "Supervisor de aprendices 2",
    apprenticeMaster: "Supervisor de aprendices",
    anApprentice: "Un aprendiz",
    age: "Edad",
    administratorCompanyContact: "Contacto de sede empresa",
    administratorCompany: "Sede de la empresa",
    address: "Dirección",
    activityCode: "Código de actividad (NAF)",
    accountExistSubTitle: "con la dirección de correo proporcionada. Por favor inicie sesión.",
    accountExist: "Ya existe una cuenta",
    aCompany: "Una empresa",
    endDate: "Fecha de fin",
    startDate: "Fecha de inicio",
    opco_submission: {
      title: "Transmitir al OPCO",
      convention: "Convenio",
      folder: "Expediente",
      confirmation: {
        title: "Confirmar la transmisión al OPCO",
        subtitle: {
          title: "Al enviar el expediente al OPCO, el CFA:",
          li_1: "Certifica la exactitud de la información mencionada en la presente solicitud",
          li_2: "Certifica que la información introducida en el formulario es conforme a la información del contrato suscrito con el aprendiz(a)",
          li_3: "Certifica que el CERFA ha sido visado por el organismo de formación responsable",
          li_4: "Certifica que el CERFA ha sido firmado por las partes (empleador, aprendiz(a) y su representante legal si procede)",
          li_5: "Se compromete a mantener los documentos justificativos a disposición de los servicios de control (OPCO, administración)",
        },
        confirm: "Confirmar el envío",
      },
      json: {
        title: "JSON enviado al OPCO",
        see: "Ver el JSON enviado",
        received: {
          title: "JSON recibido del OPCO",
          see: "Ver el JSON",
        },
      },
      success: {
        title: "Expediente transmitido con éxito",
      },
      error: {
        title: "Error de transmisión",
      },
      response: {
        title: "Respuesta OPCO",
        message: "Mensaje de respuesta",
      },
      status: {
        success: "Éxito",
        in_progress: "En curso...",
        failed: "Fallido",
        waiting: "En espera de envío",
      },
      message: {
        processing: "Envío en curso",
      },
      manual: {
        alert:
          "El empleador es responsable de la celebración y transmisión del contrato de alternancia (aprendizaje o profesionalización) a su Operador de Competencias (OPCO), o a la DREETS para los empleadores públicos, en cuanto se firme y, a más tardar, dentro de los 5 días hábiles siguientes al inicio del contrato. Este depósito es crucial para activar las ayudas económicas y garantizar la cobertura social.",
        success: "¡Envío al OPCO realizado con éxito!",
      },
    },
    opco_folder: {
      send: {
        done: "Envío a OPCO completado",
      },
      last_sync: "Última sincronización: {date}",
    },
    first_connexion: "Primera conexión",
    actor: {
      cfa: "CFA",
      ufa: "UFA",
      company: "Empresa",
    },
    legal_responsible: {
      required: "Debe añadir al menos un responsable legal (Máximo 2)",
      add: "Añadir un responsable legal",
      add_second: "Añadir un segundo responsable legal",
      edit: "Modificar un responsable legal",
      success_add: "Responsable legal añadido con éxito.",
      success_edit: "Responsable legal modificado con éxito.",
      delete: {
        success: "Responsable legal eliminado con éxito.",
        confirmation: "¿Está seguro de que desea eliminar a este responsable legal?",
      },
    },
    correction_requested: {
      title: "Solicitudes de modificación",
      historic: "Historial de solicitudes de modificación",
      creation: "Corrección solicitada por {creator} el {date}",
    },
    params: {
      give_mandat: "Configuración del mandato de gestión",
    },
    updated_cost: ({ plural, named }) => plural(["1 importe modificado", `${named("number")} importes modificados`]),
    no_updated_cost: "Ningún importe modificado",
    amendment: "Adenda",
    mission: "Misiones",
    salary: "Remuneración",
    financing_amount: "Cuadro financiero — Presupuesto",
    invoice_tab: {
      title: "Financiación/Facturación",
    },
    due_date: {
      valid: "Aceptar los vencimientos OPCO",
      edit: "Modificar el desglose",
    },
    schedule: {
      title: "Calendario de pagos",
      mode: {
        active: "Modo activo:",
        description: "OPCO = recibido a través de la API Convergence, Manual = modificado por el CFA",
        label: "Modo {mode}",
        confirmation: "¿Está seguro de que desea cambiar al modo {mode}?",
        manual_warning:
          "Si cambia al modo manual y factura un vencimiento:<br /><br />- Las facturas ya no podrán transmitirse a través de la API.<br />- El modo «OPCO» ya no estará disponible y deberá finalizar la facturación en modo manual.",
      },
      empty: "Ningún calendario de pagos por el momento",
      legend: {
        title: "Leyenda de importes",
        invoiced: "Importe facturado",
        credited: "Importe total de los abonos",
        net: "Pendiente de facturar / neto facturado",
      },
      error: "Se produjo un error al cargar el calendario de pagos",
      type_unavailable: "Este tipo de calendario no está disponible para este contrato",
      column_installment: "Vencimiento",
      column_type: "Tipo",
      column_start_date: "Inicio",
      column_end_date: "Fin",
      column_amount: "Importe",
      type: {
        initial: "Inicial",
        intermediate: "Intermedio",
        balance: "Saldo",
      },
      manual_edit: {
        edit_button: "Modificar el reparto manual",
        title: "Reparto manual de los vencimientos",
        locked: "Vencimiento bloqueado",
        locked_amount: "Importe del vencimiento {installment} (bloqueado): {amount}",
        locked_start_date: "Fecha de inicio del vencimiento {installment} (bloqueado): {date}",
        locked_end_date: "Fecha de fin del vencimiento {installment} (bloqueado): {date}",
        amount_label: "Importe del vencimiento {installment}",
        start_date_label: "Fecha de inicio del vencimiento {installment}",
        end_date_label: "Fecha de fin del vencimiento {installment}",
        add_line: "Añadir un vencimiento",
        new_line: "Nuevo vencimiento, no guardado",
        modified_line: "Vencimiento modificado, no guardado",
        change: "{field}: {before} → {after}",
        deleted_line: "Vencimiento eliminado, no guardado",
        delete_line: "Eliminar el vencimiento {installment}",
        delete_confirmation:
          "¿Eliminar este vencimiento? Su importe se trasladará al vencimiento no bloqueado más cercano.",
        reset: "Restablecer",
        reset_confirmation:
          "¿Restablecer el calendario manual? Todos los vencimientos no bloqueados serán reemplazados por el cálculo automático.",
        save: "Guardar",
        balance_target: "Importe neto comprometido",
        balance_current: "Total repartido",
        balance_gap: "Diferencia",
        balance_ok: "La suma de los plazos corresponde a los importes del expediente.",
        balance_error:
          "La suma de los importes debe ser igual al importe neto comprometido para poder añadir un vencimiento o guardar.",
        coverage_gap_error: "Los vencimientos no cubren todos los días del contrato.",
        coverage_overlap_error: "Algunos vencimientos se solapan.",
        end_date_before_start_date: "La fecha de fin de este vencimiento no puede ser anterior a su fecha de inicio.",
        start_date_out_of_pec_range:
          "La fecha de inicio de este vencimiento debe estar comprendida entre el inicio de la cobertura OPCO y el día siguiente a su fin.",
        end_date_exceeds_pec:
          "La fecha de fin de este vencimiento no puede superar el día siguiente al fin de la cobertura OPCO.",
        date_conflict: "Esta fecha crea un hueco o un solapamiento entre los vencimientos",
        show_line_errors: "Mostrar los errores de fechas del vencimiento {installment}",
        show_all_line_errors: "Mostrar los errores",
        hide_all_line_errors: "Ocultar los errores",
        lines_with_date_errors:
          "{count} vencimiento contiene errores de fechas: utilice el icono de alerta de la línea para ver el detalle. | {count} vencimientos contienen errores de fechas: utilice el icono de alerta de cada línea para ver el detalle.",
        unsaved_changes: "Algunos cambios no se han guardado. ¿Desea guardarlos antes de cerrar?",
        discard: "No guardar",
        unbalanced_changes:
          "La suma de los plazos no corresponde a los importes del expediente: sus cambios no se pueden guardar y se perderán. ¿Cerrar de todos modos?",
        invalid_coverage_changes:
          "Los vencimientos no cubren correctamente el periodo del contrato: sus cambios no se pueden guardar y se perderán. ¿Cerrar de todos modos?",
        invalid_date_changes:
          "Algunas fechas del calendario de pagos no son válidas: sus cambios no se pueden guardar y se perderán. ¿Cerrar de todos modos?",
        close_anyway: "Cerrar",
        continue_editing: "Seguir editando",
        saved: "Reparto manual guardado",
        error: "Se produjo un error al actualizar el reparto manual",
      },
    },
    export: {
      workflow: "Exportación de inscripciones (flujo)",
      contract_data: "Exportación de contratos",
      missions: "Exportar misiones",
      financial: "Exportación financiera",
    },
  },
};
